export default __webpack_public_path__ + "static/media/company_name_and_address.794a8db5.txt";